/**
 * LogbookViews - Extracted view components for LogbookFullView
 */
import React from 'react';
import { Map } from 'lucide-react';

// Map View Component (placeholder for future implementation)
export const MapView = () => (
  <div className="bg-white rounded-lg border border-gray-200 p-8">
    <div className="text-center">
      <Map className="h-16 w-16 mx-auto text-gray-400 mb-4" />
      <h3 className="text-lg font-medium text-gray-900 mb-2">Map View</h3>
      <p className="text-gray-500">
        Track vessel positions and voyage routes on an interactive map.
      </p>
      <p className="text-sm text-gray-400 mt-2">Coming soon...</p>
    </div>
  </div>
);